<template>
  <div>
    <div class="form-row mt-3 mr-5" style="align-items: center">
      <div class="col-sm-12">
        <div v-if="this.active != 1">
          <button
            type="button"
            class="btn btn-sm btn-primary el-button--default"
            v-if="this.active < 4"
            @click="previous"
            style="float: right"
          >
            <span>Previous</span>
          </button>
        </div>
      </div>
    </div>
    <el-form v-if="active === 1">
      <customerinvoice-index @id="setId" :active="{ active }"></customerinvoice-index>
    </el-form>
    <el-form v-if="active === 2">
      <customerinvoice-list :id="id" @invoiceId="invoiceid" :active="{ active }"></customerinvoice-list>
    </el-form>
    <el-form v-if="active === 3">
      <customerinvoice-view :id="invoice_id"></customerinvoice-view>
    </el-form>
  </div>
</template>

<script>

export default {
  name: "DatatableWithFilter",
  data() {
    return {
      active: 1,
      id: 0,
      invoice_id: 0,
    };
  },
  methods: {
    setId(id) {
      this.active = 2;
      this.id = Number(id);
    },
    invoiceid(id) {
      this.active = 3;
      this.invoice_id = Number(id);
    },
    previous() {
        if (this.active-- < 4) this.active = this.active--;
    },
  },
};
</script>
